import Identifier from "./Identifier.vue";
import { pluginify } from "./../../util";
export default pluginify(Identifier);
export { Identifier };
